export default __webpack_public_path__ + "9f7706b502166017d66faab6fc8e313c.png";